import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import Hero from '../../components/hero/hero';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import About from '../../components/about/about';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import MarqueeSection from '../../components/MarqueeSection/MarqueeSection';
import ProjectSection from '../../components/ProjectSection/ProjectSection';
import MarqueeSectionS2 from '../../components/MarqueeSectionS2/MarqueeSectionS2';
import AwardSection from '../../components/AwardSection/AwardSection';
import FunFact from '../../components/FunFact/FunFact';
import Testimonial from '../../components/Testimonial/Testimonial';
import MarqueeSectionS3 from '../../components/MarqueeSectionS3/MarqueeSectionS3';
import TeamSection from '../../components/TeamSection/TeamSection';
import BlogSection from '../../components/BlogSection/BlogSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import ProjecTitle from '../../components/ProjecTitle/ProjecTitle';
import Logo from '../../images/logo.svg';
import FunFactS2 from '../../components/FunFactS2/FunFactS2';
import BlogSectionS2 from '../../components/BlogSectionS2/BlogSectionS2';
import About2 from '../../components/about2/about2';
import PartnerSectionS3 from '../../components/PartnerSectionS3/PartnerSectionS3'
import ServiceSectionS3 from '../../components/ServiceSectionS3/ServiceSectionS3'

const HomePage = () => {
    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <Hero />
            <About />
            <ServiceSectionS3 />
            <About2 />
            <FunFactS2 />
            <PartnerSectionS3 />
            {/* <BlogSectionS2 /> */}
            <Footer hclass={"footer-section section-padding"} />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage;